import React from 'react'
import Button from 'shared/Buttons/Button/Button'
import css from './ContextMenu.module.css'

type Props = {
  x: number
  y: number
  onCreate: () => void
  onClose: () => void
}

export default function ContextMenu({ x, y, onCreate, onClose }: Props) {
  return (
    <div
      className={css.contextMenu}
      style={{
        position: 'fixed',
        left: x,
        top: y,
        zIndex: 1000,
      }}
    >
      <Button
        theme='grey-outline'
        style={{ border: 'none' }}
        onClick={() => {
          onCreate()
          onClose()
        }}
      >
        Создать защиту
      </Button>
    </div>
  )
}
